import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import LoginPage from "@/pages/LoginPage";
import SetupPage from "@/pages/SetupPage";
import AuthCallback from "@/pages/AuthCallback";
import AirportBusynessPage from "@/pages/AirportBusynessPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import EditorialStandardsPage from "@/pages/EditorialStandardsPage";
import CorrectionsPage from "@/pages/CorrectionsPage";
import MastheadPage from "@/pages/MastheadPage";
import AffiliateDisclosurePage from "@/pages/AffiliateDisclosurePage";
import AuthorPage from "@/pages/AuthorPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import FAQPage from "@/pages/FAQPage";
import AirportsIndexPage from "@/pages/AirportsIndexPage";
import AirportGuidePage from "@/pages/AirportGuidePage";
import MethodologyPage from "@/pages/MethodologyPage";
import BusiestNowPage from "@/pages/BusiestNowPage";
import InsightsPage from "@/pages/InsightsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import ThanksgivingForecastPage from "@/pages/ThanksgivingForecastPage";
import ChristmasForecastPage from "@/pages/ChristmasForecastPage";
import WidgetPage from "@/pages/WidgetPage";
import WeeklyReportPage from "@/pages/WeeklyReportPage";
import { Toaster } from "@/components/ui/sonner";
import { rehydrateReminders } from "@/lib/pushReminders";
import { injectSocialProfiles } from "@/components/SEOHead";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

// Re-arm any persisted reminders as soon as the app loads
if (typeof window !== "undefined") {
  injectSocialProfiles();
}
if (typeof window !== 'undefined') {
  rehydrateReminders();
}

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id - MUST be synchronous
  // This runs BEFORE ProtectedRoute to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Airport Busyness Predictor is the PUBLIC landing page - no login required */}
      <Route path="/" element={<AirportBusynessPage />} />
      <Route path="/airport" element={<AirportBusynessPage />} />
      
      {/* Content pages for SEO and AdSense */}
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/editorial-standards" element={<EditorialStandardsPage />} />
      <Route path="/corrections" element={<CorrectionsPage />} />
      <Route path="/masthead" element={<MastheadPage />} />
      <Route path="/affiliate-disclosure" element={<AffiliateDisclosurePage />} />
      <Route path="/authors/:slug" element={<AuthorPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:postId" element={<BlogPostPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/methodology" element={<MethodologyPage />} />
      
      {/* Airport Guides */}
      <Route path="/airports" element={<AirportsIndexPage />} />
      <Route path="/airports/:airportCode" element={<AirportGuidePage />} />

      {/* Live busiest airports dashboard */}
      <Route path="/live" element={<BusiestNowPage />} />
      <Route path="/busiest" element={<Navigate to="/live" replace />} />

      {/* National insights hub */}
      <Route path="/insights" element={<InsightsPage />} />
      <Route path="/thanksgiving-2026-forecast" element={<ThanksgivingForecastPage />} />
      <Route path="/christmas-2026-forecast" element={<ChristmasForecastPage />} />
      <Route path="/widget" element={<WidgetPage />} />
      <Route path="/reports" element={<WeeklyReportPage />} />
      <Route path="/reports/:weekId" element={<WeeklyReportPage />} />
      
      {/* OpenClaw setup requires authentication */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/setup" element={<SetupPage />} />
      
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <Toaster data-testid="global-toaster" richColors position="top-center" />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
